<template>
  <div class="container is-fullhd container__section-subscription">
    <section class="buy-hero hero is-primary bookman-gradient">
      <div class="hero-body">
        <div class="container">
          <div class="media">
            <figure class="media-left">
              <p class="image is-64x64">
                <img src="../assets/undraw_credit_card_df1m.svg">
              </p>
            </figure>
            <div class="media-right">
              <h1 class="title">
                Subscription
              </h1>
              <h2 class="subtitle">
                Subscribe to continue benefiting from Bookman!
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="columns is-mobile is-centered">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Yearly Plan
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <p class="subtitle is-size-2 has-text-weight-bold has-text-centered">$20 / year</p>
            </div>
            <div class="content">
              <ul>
                <li>Upload as many books (epubs, pdfs) as you want</li>
                <li>Start as many free ebooks as you want</li>
              </ul>
            </div>
          </div>
          <footer class="card-footer">
            <a href="/#/subscription" class="card-footer-item" @click="openCheckoutModal()" v-if="canSubscribe">Subscribe</a>
            <div v-if="isSubscribedUser" class="card-footer-item has-text-weight-bold">You are subscribed!</div>
          </footer>
        </div>
      </div>
    </section>

    <section class="section">
      <b-message type="is-info" has-icon>
          Bookman takes a lot of time to develop, as well as money to keep running, so the pricing is a way to ensure I can keep it going!
      </b-message>
    </section>

    <b-modal :active.sync="checkoutModal" :width="640" scroll="keep">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            Subscribe to Bookman Yearly Plan
          </p>

          <a class="card-header-icon" @click="checkoutModal = false">
            <span class="icon is-small">
            <i class="mdi mdi-close"></i>
            </span>
          </a>

        </header>
        <div class="card-content">
            <error-message/>
            <p class="subtitle" v-if="getUserCustomerId && !showFormAddCard">
              Use card ending with {{ getUserCardLast4Digit }}
            </p>
            <button class="button" v-if="getUserCustomerId && !showFormAddCard" @click="showFormAddCard = true">
              Use another card
            </button>
            <card class='stripe-card'
              v-if="showFormAddCard"
              :stripe='stripePublicKey'
              @change='checkoutComplete = $event.complete'
              :options='stripeOptions'/>
              <button class="button" v-if="getUserCustomerId && showFormAddCard" @click="showFormAddCard = false">
              Use existing card
            </button>
            <p class="card-process-description is-size-7 has-text-grey">
              Your payment information will be securely processed by Stripe.
            </p>
            <b-field label="Coupon" message="If you have a coupon, type it here">
              <b-input v-model="coupon"></b-input>
            </b-field>
        </div>
        <footer class="modal-card-foot">
          <button type="button" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-secondary" @click="subscribe()" :disabled="isBuyButtonDisabled">
            Subscribe
          </button>
          <button class="button" @click="checkoutModal = false">
            Cancel
          </button>
        </footer>
        <b-loading :is-full-page="false" :active.sync="isLocalLoading" :can-cancel="false"></b-loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Card, createToken } from 'vue-stripe-elements-plus'
import errorMessage from '@/components/error-message'

export default {
  name: 'subscription',
  data () {
    return {
      checkoutComplete: false,
      checkoutModal: false,
      coupon: null,
      selectedItem: null,
      showFormAddCard: true,
      stripeOptions: { hidePostalCode: true },
      stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      stripePlan: process.env.VUE_APP_STRIPE_PLAN
    }
  },
  watch: {
    checkoutModal (value) {
      if (value) {
        if (this.getUserCustomerId) {
          this.showFormAddCard = false
        }
      }
    }
  },
  methods: {
    async subscribe () {
      if (this.showFormAddCard) {
        const { token } = await createToken()
        const result = await this.$store.dispatch('subscribeUser', {
          coupon: this.coupon,
          plan: 'plan_E8owQBxfUEMcNT', // 'plan_E8oxh7rJ6UXsDC',
          token
        })
        if (result) {
          this.checkoutModal = false
        }
      } else {
        const result = await this.$store.dispatch('subscribeUser', {
          coupon: this.coupon,
          plan: 'plan_E8owQBxfUEMcNT' // 'plan_E8oxh7rJ6UXsDC'
        })
        if (result) {
          this.checkoutModal = false
        }
      }
    },
    openCheckoutModal (item) {
      this.checkoutModal = true
      this.selectedItem = item
    }
  },
  computed: {
    canSubscribe () {
      return this.isAuthenticated && !this.isSubscribedUser
    },
    checkoutModalTitle () {
      if (this.selectedItem) {
        return `${this.selectedItem.description} for ${this.selectedItem.price}`
      }
      return ''
    },
    getUserCardLast4Digit () {
      return this.$store.getters.getUserCardLast4Digit
    },
    getUserCustomerId () {
      return this.$store.getters.getUserCustomerId
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isBuyButtonDisabled () {
      if (this.showFormAddCard) {
        return !this.checkoutComplete
      }
      return this.isLocalLoading
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'subscription' && localLoading.active
    },
    isSubscribedUser () {
      return this.$store.getters.isSubscribedUser
    }
  },
  components: {
    errorMessage,
    Card
  }
}
</script>

<style scoped>
  .buy-hero {
    margin-top: 50px;
  }
  .card-process-description {
    margin-top: 5px;
  }

  .stripe-card {
    margin-bottom: 10px;
  }

  .ticket-description {
    padding: 0.4rem 0;
    text-align: center;
  }
</style>
